<template>
	<div>
		<input
			v-if="input.type == 'text'"
			type="text"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
			:placeholder="input.placeholder"
		/>
		<input
			v-if="input.type == 'number'"
			type="number"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
			:placeholder="input.placeholder"
		/>
		<input
			v-if="input.type == 'date'"
			type="date"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
			:placeholder="input.placeholder"
		/>
		<input
			v-if="input.type == 'password'"
			type="password"
			v-model="input.value"
			class="form-control"
			:disabled="input.disabled"
			:placeholder="input.placeholder"
		/>
		<input
			v-if="input.type == 'mask'"
			type="text"
			v-model="input.value"
			class="form-control"
			v-mask="input.mask"
			:disabled="input.disabled"
			:placeholder="input.placeholder"
		/>
		<div class="well well-sm" v-if="input.type == 'checkbox'">
			<div
				v-for="(opt, index) in input.options.options"
				:key="index"
				v-if="opt.value != ''"
				class="checkbox"
				:class="getClass(input.type, input.options.aling)"
			>
				<label>
					<input
						@click="valSel(input, opt.value)"
						:value="opt.value"
						:checked="isChecked(input, opt.value)"
						type="checkbox"
						:disabled="input.disabled"
					/>
					<span>{{ opt.text }}</span>
				</label>
			</div>
		</div>
		<div class="well well-sm" v-if="input.type == 'radio'">
			<!-- {{input.options.aling}} -->
			<div
				v-for="(opt, index) in input.options.options"
				:key="index"
				v-if="opt.value != ''"
				class="radio"
				:class="getClass(input.type, input.options.aling)"
			>
				<label>
					<input
						v-model="input.value"
						type="radio"
						:disabled="input.disabled"
						:value="opt.value"
					/>
					<span>{{ opt.text }}</span>
				</label>
			</div>
		</div>
	</div>
</template>
<script>
	// import tools from "../../../../functions/functions.js"
	export default {
		name: 'ChInputs',
		props: ['data'],
		computed: {
			input() {
				return this.data;
			},
		},

		methods: {
			isChecked(inp, val) {
				return inp.value.indexOf(val) !== -1;
			},
			getClass(type, aling) {
				if (aling !== '') {
					return type + aling;
				}
			},
			valSel(input, item) {
				let pVal = [];
				let newMark = true;

				if (input.value != '') {
					pVal = input.value.split(', ');
				}
				pVal.forEach((it, id) => {
					if (it == item) {
						pVal.splice(id, 1);
						newMark = false;
					}
				});
				if (newMark == true) {
					pVal.push(item);
				}
				input.value = pVal.join(', ');
				input.value.substring(2, input.value.length);
			},
			//isInput(type){
			// 	if(
			// 		type == "text" ||
			// 		type == "number" ||
			// 		type == "date"
			// 	) return true;
			// 	else false;
			// }
		},

		watch: {
			'input.options': function (data) {
				if (
					data.type == 'table-db' &&
					(this.input.type == 'checkbox' ||
						this.input.type == 'radio')
				) {
					const sData = {
						id: 'load-options-data',
						table: data.inTable,
					};
					// tools.send("action-sistem", sData, (rDate) => {
					// 	this.$set(this.input.options, "options", rDate)
					// }, "json")
				}
			},
		},
		mounted() {
			if (
				(this.input.type == 'checkbox' || this.input.type == 'radio') &&
				this.input.options.type == 'table-db'
			) {
				const sData = {
					id: 'load-options-data',
					table: this.input.options.inTable,
				};
				// tools.send("action-sistem", sData, (rDate) => {
				// 	this.$set(this.input.options, "options", rDate)
				// 	//console.log(rDate)
				// }, "json")
			}
		},
	};
</script>
<style scoped>
	.checkbox-inline,
	.radio-inline {
		padding-left: 10px;
	}
	.checkbox,
	.radio {
		margin: 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/inputs/chInputs.vue